export const monthNames = [
  "janvier",
  "février",
  "mars",
  "avril",
  "mai",
  "juin",
  "juillet",
  "août",
  "septembre",
  "octobre",
  "novembre",
  "décembre",
];

export const monthToDate = (monthYear) => {
  if (!monthYear || typeof monthYear !== "string" || !monthYear.includes("-"))
    return new Date();
  const [monthName, year] = monthYear.split("-");
  const monthIndex = monthNames.indexOf(monthName.toLowerCase());
  return new Date(year, monthIndex >= 0 ? monthIndex : 0);
};

export const formatMonth = (date) =>
  `${monthNames[date.getMonth()]}-${date.getFullYear()}`;

export const filterBySelectedMonth = (facturation, selectedMonth) => {
  const facturationDate = monthToDate(facturation.mois_facturation);
  const selectedDate = monthToDate(selectedMonth);
  return (
    facturationDate.getMonth() === selectedDate.getMonth() &&
    facturationDate.getFullYear() === selectedDate.getFullYear()
  );
};

// utils/dateUtils.js
export const isSameMonth = (moisFacturation, selectedMonth) => {
  const monthNames = [
    "janvier",
    "février",
    "mars",
    "avril",
    "mai",
    "juin",
    "juillet",
    "août",
    "septembre",
    "octobre",
    "novembre",
    "décembre",
  ];

  try {
    // Extrait depuis le format "mars-2024"
    const [moisStr, anneeStr] = moisFacturation.split("-");
    const moisIndex = monthNames.indexOf(moisStr.toLowerCase()) + 1;
    const moisFormate = String(moisIndex).padStart(2, "0");

    // Extrait depuis le format "2025-04"
    const [anneeSelect, moisSelect] = selectedMonth.split("-");

    return moisFormate === moisSelect && anneeStr === anneeSelect;
  } catch {
    return false;
  }
};
